import { ContactComponent } from "@Src/pages/ContactPage";
import { Box, Card, CardContent, Container, Typography } from "@mui/material";

const SupportContent = () => {
	return (
		<Box sx={{ maxWidth: 700, margin: "20px auto" }}>
			<Card>
				<CardContent>
					<Typography variant="h5" component="h2" gutterBottom>
						Contact Support
					</Typography>
					<ContactComponent />
				</CardContent>
			</Card>
		</Box>
	);
};

export const SupportList = () => {
	return (
		<Container
			maxWidth="lg"
			sx={{ py: { xs: 8, md: 12 }, position: "relative", zIndex: 1 }}
		>
			<SupportContent />
		</Container>
	);
};
